const translations = {
  page_title: 'Activity log',

  // Filters
  select_user: 'Select User',
  select_country: 'Select Country',
  select_account: 'Select Account',
  select_section: 'Select Section',
  select_action: 'Select actions',
  select_source: 'Select Source',
  this_month: 'This Month',
  last_month: 'Last Month',
  custom: 'Custom',
  additional_filters: 'Additional Filters',

  // Table columns
  date: 'Date',
  section: 'Section',
  user: 'User',
  action: 'Action',
  object: 'Object',
  source: 'Source',
  detail: 'Detail',

  // Action types
  action_created: 'Created',
  action_updated: 'Updated',
  action_deleted: 'Deleted',
  action_exported: 'Exported',
  action_modified: 'Modified',

  // Sort options
  date_desc: 'Date (Newest First)',
  date_asc: 'Date (Oldest First)',
  name_asc: 'Name (A-Z)',
  name_desc: 'Name (Z-A)',
  action_asc: 'Action (A-Z)',
  action_desc: 'Action (Z-A)',
  sort_custom: 'Sort',

  // Results
  log_found_1: '1 log found',
  logs_found_n: '{{n}} logs found',
  no_logs: 'No activity logs found',
  no_logs_to_show: 'No logs to show',
  no_activity_description: 'There are no activity logs in the selected period.',
  select_account_to_view_logs: 'Select an account to view logs',
  select_account_description: 'Choose a country and account to load activity logs.',

  view_more: 'View more',
  view_less: 'View less',

  integration: 'Integration',
};

export default translations;
